module.exports = __webpack_public_path__ + "static/media/wall3.cd485ca0.mp3";